import { useIntl } from 'react-intl'
import { CardMode } from '@models/card'
import { ActivityProps } from '@models/activities'
import { LuxIconSpinner } from '@lux/wardrobe-lib'
import CalendarActivity from './CalendarActivity/CalendarActivity'
import { formatDateLocaleCalendar } from '@/app/utils/commonFunctions'
import { useCallback, useRef } from 'react'
import _ from 'lodash'
import { localStorageBreadcrumbKey } from '@utils/export-utils'

const CalendarActivitiesList = (props: any) => {
    const {
        activities,
        loading,
        openActivity,
        currentDate,
        calendarHeight,
        onScroll,
        totalCalendarActivities,
        onScrollDown,
    } = props

    const intl = useIntl()

    const calendarActivitiesListClass = 'home-calendar-activities-list'
    const lastScrollTopRef = useRef(0)

    const onScrollDownDebounce = useCallback(_.debounce(onScrollDown, 100,  {leading: true}), []);

    const onScrollActivities = (event) => {
        onScroll(event)
        const lastScrollTop = lastScrollTopRef.current
        const scrollTop =  event.target.scrollTop
        if (scrollTop > lastScrollTop) {
            onScrollDownDebounce()
        }
        lastScrollTopRef.current = scrollTop

    }

    return (
        <div className={calendarActivitiesListClass}>
            <div className={`${calendarActivitiesListClass}__message text`}>
                {`${intl.formatMessage({
                    id: 'home.activities.message.your_activities_for_today',
                    defaultMessage: 'Your focus activities',
                })} ${`(${totalCalendarActivities || ''})`} ${
                    currentDate ? ` - ${formatDateLocaleCalendar(currentDate)}` : ``
                }`}
            </div>
            <div
                className={`${calendarActivitiesListClass}__scrollable`}
                style={{
                    height: `calc(100vh - 88px - ${calendarHeight}px - var(--smart-navbar-height))`,
                }}
                onScroll={onScrollActivities}>
                {activities?.length > 0 ? (
                    activities.map((a: ActivityProps) => (
                        <div className={`${calendarActivitiesListClass}__item`} key={a.id}>
                            <CalendarActivity
                                id={a.id}
                                title={a.title}
                                time={a.time}
                                dueTime={a.dueTime}
                                type={a.type}
                                sourceModule={a.sourceModule}
                                isMostUrgent={a.isMostUrgent}
                                status={a.status}
                                isRead={a.isRead}
                                timeZone={a.timeZone}
                                priority={a.priority}
                                mode={CardMode.SQUARE}
                                hasBorderColor={true}
                                onClick={() => {
                                    localStorage.setItem(
                                        localStorageBreadcrumbKey,
                                        window.location.href
                                    )
                                    openActivity(a)
                                }}
                            />
                        </div>
                    ))
                ) : (
                    <>
                        {!loading && intl.formatMessage({
                            id: 'home.activities.alert.no_activities_for_today_great_job',
                            defaultMessage: 'No activities for today, great job!',
                        })}
                    </>
                )}
                {loading && <LuxIconSpinner />}
            </div>
        </div>
    )
}

export default CalendarActivitiesList
